import { FC, Fragment, PropsWithChildren } from 'react';

const ToolbarItems: FC<PropsWithChildren> = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

export default ToolbarItems;
